// Runtime configuration for Pages Router
// This function reads environment variables at runtime (server-side)
export const getRuntimeVariables = async () => {
  return {
    PUBLIC_ARRIVALS_API_URL: process.env.PUBLIC_ARRIVALS_API_URL ?? '',
    PUBLIC_APP_URL: process.env.PUBLIC_APP_URL ?? '',
    PUBLIC_API_URL: process.env.PUBLIC_API_URL ?? '',
    PUBLIC_LOGIN_URL: process.env.PUBLIC_LOGIN_URL ?? '',
    PUBLIC_ARRIVAL_APP_URL: process.env.PUBLIC_ARRIVAL_APP_URL ?? '',
    PUBLIC_OWNERS_ACTIVE_ACCOUNT_COOKIE_DOMAIN:
      process.env.PUBLIC_OWNERS_ACTIVE_ACCOUNT_COOKIE_DOMAIN ?? '',
    PUBLIC_ACTIVITIES_APP_URL: process.env.PUBLIC_ACTIVITIES_APP_URL ?? '',
    PUBLIC_WIFI_CONSENT_APP_URL: process.env.PUBLIC_WIFI_CONSENT_APP_URL ?? '',
    PUBLIC_ENTERTAINMENT_APP_URL:
      process.env.PUBLIC_ENTERTAINMENT_APP_URL ?? '',
    PUBLIC_OWNERS_NAVIGATION_FRAGMENT_URL:
      process.env.PUBLIC_OWNERS_NAVIGATION_FRAGMENT_URL ?? '',
    PUBLIC_OWNERS_NAVIGATION_FRAGMENT_CLUSTER_URL:
      process.env.PUBLIC_OWNERS_NAVIGATION_FRAGMENT_CLUSTER_URL ?? '',
    PUBLIC_ENV: process.env.PUBLIC_ENV ?? '',
    PUBLIC_FULL_STORY_ORG: process.env.PUBLIC_FULL_STORY_ORG ?? '',
    PUBLIC_SONGBIRD_JS_URL: process.env.PUBLIC_SONGBIRD_JS_URL ?? '',
    PUBLIC_PAYMENT_API_URL: process.env.PUBLIC_PAYMENT_API_URL ?? '',
    PUBLIC_CYBERSOURCE_3DS_DISABLED:
      process.env.PUBLIC_CYBERSOURCE_3DS_DISABLED ?? '',
    PUBLIC_LETTINGS_API_URL: process.env.PUBLIC_LETTINGS_API_URL ?? '',
    PUBLIC_PLAY_PASS_API_URL: process.env.PUBLIC_PLAY_PASS_API_URL ?? '',
    PUBLIC_DOCUMENTS_API_URL: process.env.PUBLIC_DOCUMENTS_API_URL ?? '',
    PUBLIC_ACCOUNT_API_URL: process.env.PUBLIC_ACCOUNT_API_URL ?? '',
    PUBLIC_GTM_ID: process.env.PUBLIC_GTM_ID ?? '',
    PUBLIC_GTM_AUTH: process.env.PUBLIC_GTM_AUTH ?? '',
    PUBLIC_GTM_PREVIEW: process.env.PUBLIC_GTM_PREVIEW ?? '',
    PUBLIC_EAGLE_EYE_API_URL: process.env.PUBLIC_EAGLE_EYE_API_URL ?? '',
    PUBLIC_AUTHENTICATION_API_URL:
      process.env.PUBLIC_AUTHENTICATION_API_URL ?? '',
    PUBLIC_UNLEASH_SERVER_API_URL:
      process.env.PUBLIC_UNLEASH_SERVER_API_URL ?? '',
    PUBLIC_UNLEASH_FRONTEND_API_URL:
      process.env.PUBLIC_UNLEASH_FRONTEND_API_URL ?? '',
    UNLEASH_FRONTEND_API_TOKEN: process.env.UNLEASH_FRONTEND_API_TOKEN ?? '',
    PUBLIC_UNLEASH_APP_NAME: process.env.PUBLIC_UNLEASH_APP_NAME ?? '',
    PUBLIC_DD_VERSION: process.env.DD_VERSION ?? '',
    PUBLIC_DD_SERVICE: process.env.DD_SERVICE ?? '',
    PUBLIC_DD_DD_ENV: process.env.DD_ENV ?? '',
    PUBLIC_DD_RUM_APPLICATION_ID: process.env.DD_RUM_APPLICATION_ID ?? '',
    PUBLIC_DD_RUM_CLIENT_TOKEN: process.env.DD_RUM_CLIENT_TOKEN ?? '',
    PUBLIC_DD_RUM_SAMPLE_RATE: process.env.DD_RUM_SAMPLE_RATE ?? '',
    PUBLIC_DD_RUM_DEFAULT_PRIVACY_LEVEL:
      process.env.DD_RUM_DEFAULT_PRIVACY_LEVEL ?? '',
    PUBLIC_DD_RUM_REPLAY_SAMPLE_RATE:
      process.env.DD_RUM_REPLAY_SAMPLE_RATE ?? '',
    FESTIVE_SITE_FEES_OPT_IN_YEAR:
      process.env.FESTIVE_SITE_FEES_OPT_IN_YEAR ?? '',
    PUBLIC_PAYMENT_SAVED_CARD_DISABLED:
      process.env.PUBLIC_PAYMENT_SAVED_CARD_DISABLED ?? '',
    PUBLIC_IDENTITY_API_URL: process.env.PUBLIC_IDENTITY_API_URL ?? '',
    PUBLIC_OWNER_REWARDS_GATEWAY_URL:
      process.env.PUBLIC_OWNER_REWARDS_GATEWAY_URL ?? '',
    PUBLIC_VEHICLE_DETAILS_PARK_CODES:
      process.env.PUBLIC_VEHICLE_DETAILS_PARK_CODES ?? '',
    BASE_PATH: process.env.BASE_PATH ?? '',
  };
};
